import { useState } from "react";
import styles from "./Badges.module.scss";
import { BadgeDrawer } from "./BadgeDrawer/BadgeDrawer";
import { CleanBeautyLabels } from "@/hooks/useCleanBeauty/cleanBeautySchema.ts";
import badgesTexts from "./badgesText.json";
import { TertiaryButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";

type BadgesProps = {
  badges: CleanBeautyLabels[];
};

function transformIngredientText(badges: string) {
  return badges
    .replace(/_/, " ")
    .split(" ")
    .map(
      (word) => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase(),
    )
    .join(" ");
}

export const Badges = ({ badges }: BadgesProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [header, setHeader] = useState<string>("");
  const [description, setDescription] = useState<string[]>([]);

  const handleBadgeSelect = (badge: CleanBeautyLabels) => {
    setHeader(transformIngredientText(badge));
    setDescription(badgesTexts[badge]);
    setIsOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsOpen(false);
  };

  if (badges.length === 0) {
    return null;
  }

  return (
    <div className={styles.badges}>
      <BadgeDrawer
        isOpen={isOpen}
        handleClose={handleCloseDrawer}
        badgeHeader={header}
        description={description}
      ></BadgeDrawer>
      {badges.map((badge, index) => (
        <TertiaryButton
          key={index}
          type="button"
          onClick={() => handleBadgeSelect(badge)}
          labelText={transformIngredientText(badge)}
          width="hug"
        />
      ))}
    </div>
  );
};
